<template>
  <div
    class="app-container"
    style="min-height: calc(100vh - 136px)"
    v-loading="homeLoading"
    :element-loading-text="$t('拼命加载中')"
  >
    <div>
      <!-- 操作栏 -->
      <div class="text-bold flex-x-center flex-sub">
        <div class="title--newFont">{{ $t("委外订单详情") }}</div>
        <!-- 按钮 -->
        <div style="text-align: right">
          <el-button size="small" class="btnTwo" @click="backHome">{{
            $t("返回")
          }}</el-button>
        </div>
      </div>
      <hr />
      <div style="color: #1476C3; font-weight: 800; font-size: 16px; margin-top: 10px">
        丨{{ $t("基本信息") }}
      </div>
      <!-- 内容 -->
      <div>
        <el-descriptions
          class="margin-top"
          size="small"
          :column="5"
          border
          :label-style="labelStyle"
          :contentStyle="{ width: '220px' }"
        >
          <el-descriptions-item>
            <template slot="label">{{ $t("委外单号") }} </template>
            <span>{{ hostData.outsourcingDocNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("全局搜索码") }} </template>
            <span>{{ hostData.globalSearchNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("客户订单号") }} </template>
            <span>{{ hostData.baseCustomerSalesOrderNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("委外开始时间") }}</template>
            <span>{{ hostData.baseOutsourcingStartTime }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("交货日期") }}</template>
            <span>{{ formatDate(hostData.valueOutsourcingDeliveryDate) }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> {{ $t("委外商") }} </template>
            <span>{{ hostData.baseOutsourcingSupplierName }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> {{ $t("负责人") }} </template>
            <span>{{ hostData.baseOutsourcingChargemanName }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("其他费用") }}</template>
            <span>{{ hostData.baseOtherTotalprice }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("成品仓库") }}</template>
            <span>{{ hostData.baseOutsorWarehouseName }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("原料仓库") }}</template>
            <span>{{ hostData.baseRawmaterialWarehouseName }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> {{ $t("优先级") }} </template>
            <span>{{ hostData.priorityLevel }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("付款模式") }}</template>
            {{ hostData.paymentMode }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("委外金额") }}</template>
            {{ hostData.baseMaterialTotalprice }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> {{ $t("备注") }} </template>
            <span>{{ hostData.remark }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="table-section-header">
        <div class="table-section-title">丨{{ $t("产品信息") }}</div>
        <dialogDragSort
          v-if="tableSettingReady.mainProduct"
          :flag="tableSettingReady.mainProduct"
          :titleList="mainProductTitleList"
          @onEnd="(list) => onTableSettingChange('mainProduct', list)"
          @isShowClick="(list) => onTableSettingChange('mainProduct', list)"
          @widthClick="(list) => onTableSettingChange('mainProduct', list)"
          @resetClick="() => resetTableSetting('mainProduct')"
        />
      </div>
      <myTable
        style="margin-top: 10px"
        :id="'bill_one'"
        :columnType="'columnIndex'"
        :list="mainProductList"
        :titleList="mainProductTitleList"
        :tableBtnList="[]"
        @cellClickEvent="mainProductClickEvent"
        @resizableChange="(val) => resizableChange('mainProduct', val)"
        :dialogStatus="1"
        ref="myTableOne"
      >
      </myTable>
      <div class="table-section-header">
        <div class="table-section-title">丨{{ $t("物料信息") }}</div>
        <dialogDragSort
          v-if="tableSettingReady.material"
          :flag="tableSettingReady.material"
          :titleList="titleList"
          @onEnd="(list) => onTableSettingChange('material', list)"
          @isShowClick="(list) => onTableSettingChange('material', list)"
          @widthClick="(list) => onTableSettingChange('material', list)"
          @resetClick="() => resetTableSetting('material')"
        />
      </div>
      <myTable
        style="margin-top: 10px"
        ref="myTable"
        :columnType="'columnIndex'"
        :list="list"
        :titleList="titleList"
        :tableBtnList="tableBtnList"
        @cellClickEvent="mainProductClickEvent"
        @resizableChange="(val) => resizableChange('material', val)"
        :dialogStatus="1"
      ></myTable>
      <div class="table-section-header">
        <div class="table-section-title">丨{{ $t("收料单") }}</div>
        <dialogDragSort
          v-if="tableSettingReady.requisition"
          :flag="tableSettingReady.requisition"
          :titleList="requisitionTitleList"
          @onEnd="(list) => onTableSettingChange('requisition', list)"
          @isShowClick="(list) => onTableSettingChange('requisition', list)"
          @widthClick="(list) => onTableSettingChange('requisition', list)"
          @resetClick="() => resetTableSetting('requisition')"
        />
      </div>
      <myTable
        v-loading="requisitionLoading"
        style="margin-top: 10px"
        :id="'bill_requisition'"
        :columnType="'columnIndex'"
        :list="requisitionList"
        :titleList="requisitionTitleList"
        :tableBtnList="relatedTableBtnList"
        @btnClick="requisitionBtnClick"
        @cellClickEvent="requisitionCellClick"
        @resizableChange="(val) => resizableChange('requisition', val)"
        :dialogStatus="1"
        ref="myTableRequisition"
      />
      <div class="table-section-header">
        <div class="table-section-title">丨{{ $t("出货单") }}</div>
        <dialogDragSort
          v-if="tableSettingReady.ship"
          :flag="tableSettingReady.ship"
          :titleList="shipTitleList"
          @onEnd="(list) => onTableSettingChange('ship', list)"
          @isShowClick="(list) => onTableSettingChange('ship', list)"
          @widthClick="(list) => onTableSettingChange('ship', list)"
          @resetClick="() => resetTableSetting('ship')"
        />
      </div>
      <myTable
        v-loading="shipLoading"
        style="margin-top: 10px"
        :id="'bill_ship'"
        :columnType="'columnIndex'"
        :list="shipList"
        :titleList="shipTitleList"
        :tableBtnList="relatedTableBtnList"
        @btnClick="shipBtnClick"
        @cellClickEvent="shipCellClick"
        @resizableChange="(val) => resizableChange('ship', val)"
        :dialogStatus="1"
        ref="myTableShip"
      />
    </div>
    <myOrderDetails
      v-if="subDetailState.show"
      :visible="subDetailState.show"
      :homeIndex="subDetailState.homeIndex"
      :routeQuery="subDetailRouteQuery"
      @htmlDataDialogClose="subDetailClose"
    />
  </div>
</template>
<script>
/* eslint-disable camelcase */
import {
  outsourcingDoc_view,
  outsorRequisitionDoc_listTwo,
  outsourcingtowarehouse_getVagueList
} from '@/api/myController/outsourcing';
import { MATERIAL_REQUISITION_STATUS_OPTIONS } from '@/utils/outsourcingMaterialRequisitionStatus';
import {
  selcetSetting,
  updateSetting,
  customMenu,
  divFloat
} from '@/utils/myUtils';
export default {
  components: {},
  props: {
    // 页面传进来判断入库的值
    routeType: {
      type: Array,
      default: undefined
    },
    // 页面传进来的值
    routeQuery: {
      default: () => ({})
    }
  },
  data() {
    return {
      homeLoading: false,
      // 标签页
      activeName: 'first',
      // 页面传输数据
      hrefProData: {},
      // 主表数据
      hostData: {},
      outsourcingDoc_view,
      // 页面显示able数据
      list: [],
      titleList: [
        {
          id: 1,
          name: this.$t('物料图片'),
          value: 'baseImgUrl',
          fixedState: false,
          isShow: true,
          dataType: 'image',
          selectOptionKey: '',
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 95
        },
        {
          id: 0,
          name: this.$t('物料图纸'),
          value: 'baseDrawingFile',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 60
        },
        {
          id: 0,
          name: this.$t('物料附件'),
          value: 'baseFileList',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 60
        },
        {
          name: this.$t('物料编号'),
          value: 'baseMaterialNumber',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          color: '#1476c3',
          selectOptionKey: '',
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 120
        },
        {
          id: 1,
          name: this.$t('物料名称'),
          value: 'baseMaterialName',
          fixedState: false,
          isShow: true,
          dataType: 'customTable',
          alwaysEditState: false,
          canEdit: false,
          width: 120
        },
        {
          id: 2,
          name: this.$t('规格'),
          value: 'specifications',
          fixedState: false,
          isShow: true,
          dataType: 'textList',
          alwaysEditState: false,
          canEdit: false,
          width: 180
        },
        {
          id: 2,
          name: this.$t('客户料号'),
          value: 'baseCustomerMaterialNumber',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          alwaysEditState: false,
          canEdit: false,
          width: 180
        },
        {
          id: 8,
          name: this.$t('需求数量'),
          value: 'valueMaterialQuantity',
          fixedState: false,
          isShow: true,
          dataType: 'number',
          alwaysEditState: false,
          canEdit: false,
          width: 90
        },
        {
          id: 7,
          name: this.$t('单位'),
          value: 'baseMaterialUnitName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          alwaysEditState: false,
          canEdit: false,
          width: 90
        },
        {
          id: 11,
          name: this.$t('备注'),
          value: 'remark',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          alwaysEditState: false,
          canEdit: false
        }
      ],
      // dialog数据
      dialogState: {
        show1: false,
        show2: false,
        show3: false,
        show4: false
      },
      globalSearchDialogData: {},
      materialNumberDialogData: {},
      // *************主表状态
      labelStyle: {
        'text-align': 'center',
        'font-weight': '600',
        'min-width': '110px',
        'word-break': 'keep-all',
        height: '41px'
      },
      mainProductList: [],
      // 主产品
      mainProductTitleList: [
        {
          id: 1,
          name: this.$t('产品图片'),
          value: 'baseImgUrl',
          fixedState: false,
          isShow: true,
          dataType: 'image',
          selectOptionKey: '',
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 95
        },
        {
          id: 0,
          name: this.$t('产品图纸'),
          value: 'baseDrawingFile',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 60
        },
        {
          id: 0,
          name: this.$t('产品附件'),
          value: 'baseFileList',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 60
        },
        {
          id: 0,
          name: this.$t('订单图片'),
          value: 'valueImgList',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 60
        },
        {
          id: 0,
          name: this.$t('订单附件'),
          value: 'valueFileList',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 60
        },
        {
          name: this.$t('产品编号'),
          value: 'baseMaterialNumber',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          color: '#1476c3',
          selectOptionKey: '',
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 120
        },
        {
          id: 1,
          name: this.$t('产品名称'),
          value: 'baseMaterialName',
          fixedState: false,
          isShow: true,
          dataType: 'customTable',
          alwaysEditState: false,
          canEdit: false,
          width: 120
        },
        {
          id: 2,
          name: this.$t('规格'),
          value: 'specifications',
          fixedState: false,
          isShow: true,
          dataType: 'textList',
          alwaysEditState: false,
          canEdit: false,
          width: 180
        },
        {
          id: 2,
          name: this.$t('客户料号'),
          value: 'baseCustomerMaterialNumber',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          alwaysEditState: false,
          canEdit: false,
          width: 180
        },
        {
          id: 4,
          name: this.$t('单价'),
          value: 'baseMaterialUnitprice',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          alwaysEditState: false,
          canEdit: false,
          width: 60
        },
        {
          id: 8,
          name: this.$t('委外数量'),
          value: 'baseOutsourcingQuantity',
          fixedState: false,
          isShow: true,
          dataType: 'number',
          alwaysEditState: false,
          canEdit: false,
          width: 90
        },
        {
          id: 7,
          name: this.$t('单位'),
          value: 'baseMaterialUnitName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          alwaysEditState: false,
          canEdit: false,
          width: 90
        },
        {
          id: 9,
          name: this.$t('委外金额'),
          value: 'baseMaterialTotalprice',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          selectOptionKey: '',
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 90
        },
        {
          id: 11,
          name: this.$t('备注'),
          value: 'remark',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          alwaysEditState: false,
          canEdit: false
        }
      ],
      // --------------------文件上传
      singleRowData: {},
      tableList: [],
      dialogType: 1,
      dialogStatus: 1,
      dialogTitle: '',
      markIndex: 1,
      requisitionLoading: false,
      shipLoading: false,
      requisitionList: [],
      shipList: [],
      relatedTableBtnList: ['详情'],
      relatedOrderParam: {
        asc: false,
        dateAggregateBy: '',
        fieldName: 'createTime'
      },
      relatedPageParam: {
        pageNum: 1,
        pageSize: 500
      },
      subDetailState: {
        show: false,
        homeIndex: 48
      },
      subDetailRouteQuery: {},
      requisitionTitleList: [
        {
          id: 1,
          name: this.$t('收料单号'),
          value: 'outsourcingRequisitionDocNumber',
          isShow: true,
          dataType: 'text',
          color: '#409eff',
          canEdit: false,
          width: 140
        },
        {
          id: 2,
          name: this.$t('收料日期'),
          value: 'baseRequisitionTime',
          isShow: true,
          dataType: 'dateTime',
          canEdit: false,
          width: 120
        },
        {
          id: 3,
          name: this.$t('物料编号'),
          value: 'baseMaterialNumber',
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 120
        },
        {
          id: 4,
          name: this.$t('物料名称'),
          value: 'baseMaterialName',
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 150
        },
        {
          id: 5,
          name: this.$t('收料数量'),
          value: 'baseRequisitionQuantity',
          isShow: true,
          dataType: 'number',
          canEdit: false,
          width: 100
        },
        {
          id: 6,
          name: this.$t('收料情况'),
          value: 'statusMaterialRequisition',
          isShow: true,
          dataType: 'customSelect',
          selectOptionList: MATERIAL_REQUISITION_STATUS_OPTIONS,
          canEdit: false,
          width: 100
        },
        {
          id: 7,
          name: this.$t('收货确认人'),
          value: 'baseConfirmmanName',
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 110
        }
      ],
      shipTitleList: [
        {
          id: 1,
          name: this.$t('出货单号'),
          value: 'outsourcingtowarehouseNumber',
          isShow: true,
          dataType: 'text',
          color: '#409eff',
          canEdit: false,
          width: 150
        },
        {
          id: 2,
          name: this.$t('入库日期'),
          value: 'baseInwarehouseTime',
          isShow: true,
          dataType: 'dateTime',
          canEdit: false,
          width: 120
        },
        {
          id: 3,
          name: this.$t('产品编号'),
          value: 'baseMaterialNumber',
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 120
        },
        {
          id: 4,
          name: this.$t('产品名称'),
          value: 'baseMaterialName',
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 150
        },
        {
          id: 5,
          name: this.$t('出货数量'),
          value: 'baseOutsourcingFinishedQuantity',
          isShow: true,
          dataType: 'number',
          canEdit: false,
          width: 100
        },
        {
          id: 6,
          name: this.$t('状态'),
          value: 'statusCheck',
          isShow: true,
          dataType: 'customSelect',
          selectOptionList: [
            {
              label: '已审核',
              value: 1,
              color: 'white',
              backGroundColor: 'rgb(103,194,58)'
            },
            {
              label: '未审核',
              value: 0,
              color: 'black',
              backGroundColor: 'rgb(220,223,230)'
            }
          ],
          canEdit: false,
          width: 90
        },
        {
          id: 7,
          name: this.$t('操作人'),
          value: 'baseInwarehousemanName',
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 100
        }
      ],
      tableSettingKeys: {
        mainProduct: 'outsourcingProduct_order_details_product',
        material: 'outsourcingProduct_order_details_material',
        requisition: 'outsourcingProduct_order_details_requisition',
        ship: 'outsourcingProduct_order_details_ship'
      },
      defaultTitleLists: {},
      tableSettingReady: {
        mainProduct: false,
        material: false,
        requisition: false,
        ship: false
      }
    };
  },
  created() {
    this.cacheDefaultTitleLists();
    this.initAllTableSettings();
    this.getList();
  },
  methods: {
    // 多语言
    $t(value) {
      return value;
    },
    cacheDefaultTitleLists() {
      this.defaultTitleLists = {
        mainProduct: JSON.parse(JSON.stringify(this.mainProductTitleList)),
        material: JSON.parse(JSON.stringify(this.titleList)),
        requisition: JSON.parse(JSON.stringify(this.requisitionTitleList)),
        ship: JSON.parse(JSON.stringify(this.shipTitleList))
      };
    },
    getTitleListProp(configKey) {
      const map = {
        mainProduct: 'mainProductTitleList',
        material: 'titleList',
        requisition: 'requisitionTitleList',
        ship: 'shipTitleList'
      };
      return map[configKey];
    },
    async initAllTableSettings() {
      const keys = Object.keys(this.tableSettingKeys);
      await Promise.all(keys.map((key) => this.loadTableSetting(key)));
      keys.forEach((key) => {
        this.tableSettingReady[key] = true;
      });
    },
    async loadTableSetting(configKey) {
      const menuKey = this.tableSettingKeys[configKey];
      const titleListProp = this.getTitleListProp(configKey);
      const defaultList = JSON.parse(
        JSON.stringify(this.defaultTitleLists[configKey] || [])
      );
      const saved = await selcetSetting(menuKey);
      if (saved == null) {
        this[titleListProp] = defaultList;
        updateSetting(this, menuKey, JSON.stringify(this[titleListProp]));
      } else {
        this[titleListProp] = customMenu(saved, defaultList, []);
      }
    },
    onTableSettingChange(configKey, titleList) {
      const titleListProp = this.getTitleListProp(configKey);
      this[titleListProp] = titleList;
      updateSetting(
        this,
        this.tableSettingKeys[configKey],
        JSON.stringify(titleList)
      );
    },
    resetTableSetting(configKey) {
      const titleListProp = this.getTitleListProp(configKey);
      const defaultList = JSON.parse(
        JSON.stringify(this.defaultTitleLists[configKey] || [])
      );
      this[titleListProp] = defaultList;
      updateSetting(
        this,
        this.tableSettingKeys[configKey],
        JSON.stringify(defaultList)
      );
    },
    resizableChange(configKey, val) {
      const titleListProp = this.getTitleListProp(configKey);
      this[titleListProp].forEach((item) => {
        if (item.value === val.field && item.name === val.title) {
          item.width = val.renderWidth;
        }
      });
      updateSetting(
        this,
        this.tableSettingKeys[configKey],
        JSON.stringify(this[titleListProp])
      );
    },
    getList() {
      this.homeLoading = true;
      outsourcingDoc_view({
        outsourcingDocId: this.routeQuery.outsourcingDocId
      }).then((res) => {
        const data = res.data.data || {};
        if (data.baseProcessIdlist) {
          try {
            data.baseProcessIdlist = JSON.parse(data.baseProcessIdlist);
          } catch (error) {}
        }
        try {
          let modelCtrl = JSON.parse(data.modelCtrl);
          data.modelCtrls = parseFloat(modelCtrl.STATEMENT_TYPE);
        } catch (error) {}
        // 处理主表
        try {
          if (data.sysDocExtVo) {
            this.sysEntityExtDto = data.sysDocExtVo;
          } else {
            this.sysEntityExtDto = {};
          }
        } catch (error) {
          this.sysEntityExtDto = {};
        }
        data.modelCtrlss = '';
        (data.outsourcingDocMaterials || []).forEach((item) => {
          try {
            item.specifications = JSON.parse(item.baseMaterialSpecDesc);
          } catch (error) {
            item.specifications = [];
          }
          item.materialId = item.baseMaterialId;
          item.specGroupId = item.baseMaterialSpecgroupId;
          item.baseMaterialQuantity = divFloat(
            item.valueMaterialQuantity,
            data.baseOutsourcingQuantity
          );
        });
        this.hostData = data;
        try {
          this.hostData.specifications = JSON.parse(this.hostData.baseMaterialSpecDesc);
        } catch (error) {}
        this.mainProductList = [this.hostData];
        this.list = data.outsourcingDocMaterials || [];
        this.homeLoading = false;
        this.loadRelatedDocLists(this.hostData);
      }).catch(() => {
        this.hostData = {};
        this.mainProductList = [];
        this.list = [];
        this.requisitionList = [];
        this.shipList = [];
        this.homeLoading = false;
      });
    },
    normalizeRequisitionRows(list) {
      return list.map((item) => {
        try {
          item.specifications = JSON.parse(item.baseSpecgroupDesc);
        } catch (error) {
          item.specifications = [];
        }
        return item;
      });
    },
    normalizeShipRows(list) {
      return list.map((item) => {
        try {
          item.specifications = JSON.parse(item.baseSpecgroupDesc);
        } catch (error) {
          item.specifications = [];
        }
        return item;
      });
    },
    loadRelatedDocLists(hostData) {
      const docId = hostData.outsourcingDocId;
      if (!docId) {
        this.requisitionList = [];
        this.shipList = [];
        return;
      }
      const docFilter = { baseOutsourcingDocId: docId };
      this.requisitionLoading = true;
      this.shipLoading = true;
      Promise.all([
        outsorRequisitionDoc_listTwo({
          orderParam: [this.relatedOrderParam],
          outsorRequisitionDocFilter: docFilter,
          pageParam: this.relatedPageParam
        }),
        outsourcingtowarehouse_getVagueList({
          orderParam: [this.relatedOrderParam],
          outsourcingtowarehouseFilter: docFilter,
          pageParam: this.relatedPageParam
        })
      ])
        .then(([reqRes, shipRes]) => {
          const reqPage = reqRes.data.data || {};
          const shipPage = shipRes.data.data || {};
          this.requisitionList = this.normalizeRequisitionRows(
            reqPage.dataList || []
          );
          this.shipList = this.normalizeShipRows(shipPage.dataList || []);
        })
        .catch(() => {
          this.requisitionList = [];
          this.shipList = [];
        })
        .finally(() => {
          this.requisitionLoading = false;
          this.shipLoading = false;
        });
    },
    openRequisitionDetail(row) {
      this.subDetailRouteQuery = row;
      this.subDetailState.homeIndex = 48;
      this.subDetailState.show = true;
    },
    openShipDetail(row) {
      this.subDetailRouteQuery = row;
      this.subDetailState.homeIndex = 50;
      this.subDetailState.show = true;
    },
    requisitionBtnClick(row, item) {
      if (item === '详情') {
        this.openRequisitionDetail(row);
      }
    },
    shipBtnClick(row, item) {
      if (item === '详情') {
        this.openShipDetail(row);
      }
    },
    requisitionCellClick(row, column) {
      if (column.field === 'outsourcingRequisitionDocNumber') {
        this.openRequisitionDetail(row);
      }
    },
    shipCellClick(row, column) {
      if (column.field === 'outsourcingtowarehouseNumber') {
        this.openShipDetail(row);
      }
    },
    subDetailClose() {
      this.subDetailState.show = false;
      this.subDetailRouteQuery = {};
    },
    customSelectDataShow(val, list) {
      if (list) {
        let single = list.filter((item) => {
          return item.value === val;
        });
        return single.length > 0 ? single[0].label : '';
      }
    },
    specListShow(list) {
      let text = '';
      try {
        for (let i = 0; i < list.length; i++) {
          let kong = i === list.length - 1 ? '' : '/';
          text += list[i].specKey + ':' + list[i].specValue + kong;
        }
      } catch (error) {}
      return text;
    },
    mainProductClickEvent(row, column) {
      switch (column.title) {
        default:
          break;
      }
    },
    formatDate(time) {
      return this.$moment(time).format('YYYY-MM-DD'); // 获取当前时间
    },
    backHome() {
      this.$emit('backHome');
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
/*  */
.spanBtn {
  color: #1476C3;
  font-size: 14px;
  cursor: pointer;
  width: 96px;
  text-align: center;
  line-height: 30px;
  float: left;
}

.tableContentTitle {
  height: 32px;
  line-height: 32px;
  background-color: #f8f8f9;
  font-size: 12px;
  margin-top: 10px;
  border: 1px solid #e8eaec;
  border-bottom: 0;
  padding-left: 40px;
}

.tableContent {
  width: 99%;
  margin: 0px auto;
  table-layout: fixed;
  word-wrap: break-word;
  border-collapse: collapse;
  font-size: 12px;
  border-left: 1px solid #e8eaec;
}

.tableContent td {
  height: 34px;
  background-color: #ffffff;
  border: 1px solid #e8eaec;
  border-left: 0px;
  color: black;
  text-align: center;
  padding-left: 4px;
}

.tableTitle {
  width: 99%;
  margin: 0 auto;
  table-layout: fixed;
  word-wrap: break-word;
  border-collapse: collapse;
  font-size: 14px;
  border-left: 1px solid #e8eaec;
}

.tableTitle td {
  height: 34px;
  background-color: #f8f8f9;
  border: 1px solid #e8eaec;
  border-left: 0px;
  color: black;
  text-align: center;
  padding-left: 4px;
}

.td_center {
  text-align: center;
}

//
.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  /* flex-direction: row ;
        justify-content:center; */
}

.title----font {
  color: #1476c3;
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}

.input {
  width: 180px;
  margin-right: 20px;
}

.btnOne {
  background: #1476C3;
  color: white;
  margin-right: 20px;
}

.related-empty {
  margin: 10px 0 16px;
  padding: 20px;
  text-align: center;
  color: #909399;
  background: #f8fbfc;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
}

.table-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

.table-section-title {
  color: #1476c3;
  font-weight: 800;
  font-size: 16px;
}
</style>
